import React from 'react';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const ProgressBarsComponent = ({ progress = {}, onCategorySelect = () => {} }) => {
  const categories = [
    "Underhand Passing",
    "Overhead Passing",
    "Serving",
    "Attacking",
    "Blocking",
    "Positioning"
  ];

  return (
    <div className="container card" style={{ width: '90%', marginTop: '2rem' }}>
      {categories.map((category) => {
        const { completed = 0, total = 12 } = progress[category] || {};
        const percent = Math.round((completed / total) * 100);

        // Choose progress bar color based on percent
        let barClass = 'progress-fill progress-beginner';
        if (percent >= 80) barClass = 'progress-fill progress-advanced';
        else if (percent >= 40) barClass = 'progress-fill progress-intermediate';

        return (
          <div className="mb-4" key={category}>
            <h4 className="mb-1">{category} - {percent}%</h4>
            <div className="flex-row" style={{ alignItems: 'center', gap: '1rem' }}>
              <div className="progress-bar-container" style={{ flex: 1 }}>
                <div className={barClass} style={{ width: `${percent}%` }}></div>
              </div>
              <button
                className="btn-secondary"
                onClick={() => onCategorySelect(category)}
              >
                Details
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBarsComponent;
